/**
 * 更多：在按钮下方弹出完整右键菜单（ContextMenu），并触发 more 埋点。
 */
import React from 'react';
import { getLocaleStore } from '@/i18n';
import { type ContextMenuPlugin } from '@/plugins/context-menu';
import { type ShortcutMenu } from '../shortcut-menu';
import { SHORTCUT_FUNC_MAP, type IShortcutMenuItemRenderArgs } from '../type';
import { ShortcutToolbarIconItem } from '../views/shortcut-toolbar-widgets';

const tryGetContextMenuPlugin = (framework: IShortcutMenuItemRenderArgs['framework']) => {
    const instance = framework.service.registration.getInstance<ContextMenuPlugin>('ContextMenuPlugin');
    if (!instance) {
        throw new Error('ContextMenuPlugin is not found');
    }
    return instance;
};

export const moreMenuShortcutItemRender = ({ framework }: IShortcutMenuItemRenderArgs) => {
    const { $t } = getLocaleStore();

    return (
        <ShortcutToolbarIconItem
            name="EllipsisBold"
            title={$t((v) => v.baseLayer.shortcutOperate.more)}
            onMouseDown={(e) => {
                e.stopPropagation();
            }}
            onClick={(e) => {
                const { top, height, left } = e.currentTarget.getBoundingClientRect();
                tryGetContextMenuPlugin(framework).show({
                    x: left,
                    y: top + height + 10,
                });
                framework.service.registration
                    .getInstance<ShortcutMenu>('ShortcutMenu')
                    .emitClick(SHORTCUT_FUNC_MAP.more);
            }}
        />
    );
};
